// Core score values - scores are recorded against this table.
export const results = [
	{
		id: 'A',
		name: 'cdc-own-scheme',
		label: <div><img style="padding-bottom:15px;" src="/assets/aon_logo_2.png"/><img style="max-width:100%; padding-bottom:15px;" src="/assets/cdc-end-banner.png"/>
		<div className="resultBox"><h2>Result:</h2></div><div className="answerBox"><h1>CDC - own scheme</h1></div></div>,
		description: <div>

		<p>A CDC pension scheme is a new type of pension scheme. The contributions for both the employer and the member are fixed at the point they are paid – no retrospective contributions will ever be required. The collective nature of a CDC pension scheme means that money is pooled together to target a level of pension for the member. By investing collectively, and sharing risk between members, better member outcomes can be achieved by guaranteeing a pension payable for life and investing in different types of assets over a longer time horizon than would otherwise be the case for the individual in a DC pension scheme. A CDC pension scheme maximises the income payable from a pension scheme for life.</p>
		<p><b>How did you score?</b> Your answers suggested that establishing your own CDC pension scheme is expected to be the best option for you and your workforce. You would be able to design a bespoke CDC pension scheme for your workforce and have more control over it than other types of CDC pension scheme.</p>
		<p>Own CDC pension schemes can be established for the workforce of a single employer or for employers in the same corporate group. The good news is that under the Pensions Schemes Act 2021 these types of schemes are already permitted. The regulations that will follow later in 2021 are expected to act as a blueprint for others who are interested in establishing their own CDC pension scheme, and are expected to be sufficiently flexible to allow schemes to select their own design principles, for instance, contribution rates, accrual rates, indexation.</p>
		<p>As a next step, you may want to explore potential changes to the provision of benefits and how well CDC could meet the future needs of your workforce and fit with your corporate values. If so, please get in contact with us as we would be delighted to hear from you.  Chintan Gandhi (+44 (0) 1372 733 322, chintan.gandhi@aon.com) or Matthew Arends (+44 (0)20 7068 4261, matthew.arends@aon.com).</p></div>
	},
	{
		id: 'B',
		name: 'cdc-multi-employer-scheme',
		label: <div><img style="padding-bottom:15px;" src="/assets/aon_logo_2.png"/><img style="max-width:100%; padding-bottom:15px;" src="/assets/cdc-end-banner.png"/>
		<div className="resultBox"><h2>Result:</h2></div><div className="answerBox"><h1>CDC - multi-employer scheme</h1></div></div>,
		description: <div>
		<p>A CDC pension scheme is a new type of pension scheme. The contributions for both the employer and the member are fixed at the point they are paid – no retrospective contributions will ever be required. The collective nature of a CDC pension scheme means that money is pooled together to target a level of pension for the member. By investing collectively, and sharing risk between members, better member outcomes can be achieved by guaranteeing a pension payable for life and investing in different types of assets over a longer time horizon than would otherwise be the case for the individual in a DC pension scheme. A CDC pension scheme maximises the income payable from a pension scheme for life.</p>

		<p><b>How did you score?</b> Your answers suggested that joining a multi-employer CDC pension scheme may be the best option for you and your workforce. You may want to express an interest now for the possibility of joining a multi-employer CDC pension scheme at some point in the future. This option might suit you and your workforce best as a multi-employer scheme keeps costs low due to economies of scale, and has the reassurance that the design will be used by many employers. Unless they choose to transfer out before retirement, your workforce will be guaranteed to receive a pension for life. The pension will be higher than alternatives that are guaranteed for life, such as an annuity, although the pension increases will fluctuate.</p>

		<p>The government has indicated that they are likely to allow multi-employer CDC pension schemes from late 2022. As a next step, you may want to join a group of other interested employers. This will also help the government to know that there are more employers interested, which will help them keep on track with new legislation. You will also be able to explore potential changes to the provision of benefits and how well CDC could meet the future needs of your workforce and fit with your corporate values. If so, please get in contact with us as we would be delighted to hear from you.  Chintan Gandhi (+44 (0) 1372 733 322, chintan.gandhi@aon.com) or Matthew Arends (+44 (0)20 7068 4261, matthew.arends@aon.com).</p>

		</div>
	},
	{
		id: 'C',
		name: 'cdc-decumulation-only',
		label: <div><img style="padding-bottom:15px;" src="/assets/aon_logo_2.png"/><img style="max-width:100%; padding-bottom:15px;" src="/assets/cdc-end-banner.png"/>
		<div className="resultBox"><h2>Result:</h2></div><div className="answerBox"><h1>CDC - decumulation only</h1></div></div>,
		description: <div>
		<p>A CDC pension scheme is a new type of pension scheme. The contributions for both the employer and the member are fixed at the point they are paid – no retrospective contributions will ever be required. The collective nature of a CDC pension scheme means that money is pooled together to target a level of pension for the member. By investing collectively, and sharing risk between members, better member outcomes can be achieved by guaranteeing a pension payable for life and investing in different types of assets over a longer time horizon than would otherwise be the case for the individual in a DC pension scheme. A CDC pension scheme maximises the income payable from a pension scheme for life.</p>

		<p><b>How did you score?</b> Your answers suggested that a decumulation only CDC pension scheme may be the best option for you and your workforce. This suggests that it may be best for you if your workforce built up traditional DC funds before retirement and give the option at retirement to purchase a CDC pension. Members will still have the option to transfer, take cash, purchase an annuity or draw down their pension over time. However, by purchasing a decumulation only CDC pension, members will be guaranteed a pension for life and that pension will be much higher than an annuity purchased from an insurance company – their lifetime pension income is maximised for the amount of money paid.</p>

		<p>At this stage, we do not know when the government will legislate to allow decumulation only CDC pension schemes. As a next step, you may want to join a group of other interested employers. This will also help the government to know that there are more employers interested, which will help them keep on track with new legislation. You will also be able to explore potential changes to the provision of benefits and how well CDC could meet the future needs of your workforce and fit with your corporate values. If so, please get in contact with us as we would be delighted to hear from you.  Chintan Gandhi (+44 (0) 1372 733 322, chintan.gandhi@aon.com) or Matthew Arends (+44 (0)20 7068 4261, matthew.arends@aon.com).</p>
		</div>
	},
	{
		id: 'D',
		name: 'no-change',
		label: <div><img style="padding-bottom:15px;" src="/assets/aon_logo_2.png"/><img style="max-width:100%; padding-bottom:15px;" src="/assets/cdc-end-banner.png"/>
		<div className="resultBox"><h2>Result:</h2></div><div className="answerBox"><h1>No change at this time</h1></div></div>,
		description: <div>
		<p>A CDC pension scheme is a new type of pension scheme. The contributions for both the employer and the member are fixed at the point they are paid – no retrospective contributions will ever be required. The collective nature of a CDC pension scheme means that money is pooled together to target a level of pension for the member. By investing collectively, and sharing risk between members, better member outcomes can be achieved by guaranteeing a pension payable for life and investing in different types of assets over a longer time horizon than would otherwise be the case for the individual in a DC pension scheme. A CDC pension scheme maximises the income payable from a pension scheme for life.</p>

		<p><b>How did you score?</b> Your answers suggested that now would not be the best time to pursue a change to the provision of pension benefits for your workforce. CDC pension schemes are not suitable for all employers.</p>

		<p>Given your interest in CDC, you may want to keep abreast of the developments in the UK for the introduction of CDC pension schemes and the different variations that will be possible. We are imminently expecting regulations to be passed to enable own CDC pension schemes to be established for the workforce of a single employer or for employers in the same corporate group. The government intends to consult on allowing CDC schemes for unconnected employers in due course.</p>

		<p>Please feel to subscribe to our mailings by emailing Chintan Gandhi (chintan.gandhi@aon.com) and follow us on Linkedin [Chintan Gandhi - Partner - Aon | LinkedIn and Matthew Arends - Head of UK Retirement Policy - Aon | LinkedIn].</p>
		</div>
	}
];

// Criteria that is evaluated on every answer
export const globalLogic = [
	{
		scores: { D: 999 },
		skipToEnd: true,
		conditions: [
			{ type: 'response', questionId: 5, value: 'no' },
			{ type: 'response', questionId: 6, value: 'definitely' },
			{ type: 'response', questionId: 7, value: 'guaranteed' }
		]
	}
];

// Core questions
export const questions = [
	{
		id: 1,
		label: 'What type of scheme are your employees currently contributing to?',
		options: [
			{ label: 'Defined benefit', scores: { A: 4, B: 3, C: 2, D: 1 }, modifiers: ['DB'] },
			{ label: 'Defined contribution', scores: { A: 4, B: 3, C: 2, D: 1 }, modifiers: ['DC'] },
			{ label: 'Defined benefit & Defined contribution', scores: { A: 4, B: 3, C: 2, D: 1 }, modifiers: ['DB&DC'] },
		],
	},
	{
		id: 2,
		label: 'Are you looking to review your pension vehicle in the next 5 years?',
		options: [
			{ label: 'Yes', scores: { A: 10, B: 10, C: 0, D: 0 } },
			{ label: 'Maybe', scores: { A: 10, B: 10, C: 10, D: 10 } },
			{ label: 'No', scores: { A: 0, B: 0, C: 10, D: 20 }, modifiers: ['DEMINIMIS'] },
		],
	},
	{
		id: 3,
		label: 'What is the size of your UK workforce',
		options: [
			{ label: 'greater than 5,000', scores: { A: 30, B: 10, C: 10, D: 10 } },
			{ label: 'less than 5,000', scores: { A: 0, B: 10, C: 10, D: 10 } },
		],
		conditions: []
	},
	{
		id: 4,
		label: 'Are you concerned about high ongoing costs of operating a scheme?',
		options: [
			{ label: 'Yes', scores: { A: 0, B: 10, C: 10, D: 0 } },
			{ label: 'No', scores: { A: 10, B: 10, C: 0, D: 0 } },
		],
		conditions: []
	},
	{
		id: 5,
		label: 'Would you prefer a fixed employer contribution?',
		options: [
			{ label: 'Yes', scores: { A: 10, B: 10, C: 10, D: 0 } },
			{ id: 'no', label: 'No', scores: { A: 0, B: 0, C: 0, D: 10 } },
		],
		conditions: [
			{ type: 'modifier', match: ['DB&DC', 'DB'] }
		]
	},
	{
		id: 6,
		label: 'Would you like your employees to have an income for life?',
		options: [
			{
				id: 'definitely',
				label: 'Definitely - although they could transfer to a pension scheme with alternative options',
				scores: { A: 20, B: 20, C: 0, D: 0 }
			},
			{
				label: 'Yes - although this should just be the default option',
				scores: { A: 0, B: 0, C: 20, D: 0 }
			},
			{
				id: 'no',
				label: 'No - employees should have complete freedom without being pushed in any particular direction',
				scores: { A: 0, B: 0, C: 20, D: 20 },
				scoreConditions: {
					C: [
						{ type: 'modifier', match: 'DB' },
					],
					D: [
						{ type: 'modifier', match: ['DC', 'DB&DC' ] }
					]
				}
			}
		]
	},
	{
		id: 7,
		label: 'Do you think your employees should have a guaranteed income or a higher, variable income?',
		options: [
			{ id: 'guaranteed', label: 'Guaranteed income', scores: { A: 0, B: 0, C: 0, D: 30 } },
			{ label: 'Higher, variable income', scores: { A: 30, B: 30, C: 30, D: 0 } },
		],
		conditions: [
			{ type: 'response', questionId: 6, criteria: '!==', value: 'no' }
		]
	},
	{
		id: 8,
		label: 'Would you prefer to design your own benefit structure (with slightly higher expenses) or have an off-the-shelf benefit structure?',
		options: [
			{ label: 'Own benefit structure', scores: { A: 20, B: 0, C: 0, D: 20 } },
			{ label: 'Off-the-shelf benefit structure', scores: { A: 0, B: 20, C: 20, D: 20 } },
		],
	},
	{
		// Condition modifier !== DC
		id: '9a',
		label: 'Does your scheme provide employees with a good outcome at retirement?',
		options: [
			{
				label: 'Yes',
				scores: { A: 0, B: 0, C: 20, D: 20 },
				scoreConditions: {
					C: [
						{ type: 'modifier', match: ['DC', 'DB&DC'] },
					]
				},
			},
			{ label: 'No', scores: { A: 20, B: 20, C: 20, D: 0 } },
			{ label: 'Don\'t know', scores: { A: 0, B: 0, C: 0, D: 0 } }
		],
		conditions: [
			{ type: 'modifier', match: ['DB&DC', 'DB'] }
		]
	},
	{
		// Condition modifier === DC
		id: '9b',
		label: 'Do you think your employees are saving enough for their retirement?',
		options: [
			{ label: 'Yes', scores: { A: 0, B: 0, C: 20, D: 20 } },
			{ label: 'No', scores: { A: 20, B: 20, C: 20, D: 0 } },
			{ label: 'Don\'t know', scores: { A: 0, B: 0, C: 0, D: 0 } }
		],
		conditions: [
			{ type: 'modifier', match: 'DC' }
		]
	},
	{
		id: '10',
		label: 'Are you concerned about employees running out of retirement income?',
		options: [
			{ label: 'Yes', scores: { A: 20, B: 20, C: 20, D: 0 } },
			{ label: 'No', scores: { A: 0, B: 0, C: 0, D: 20 } },
		],
		conditions: [
			{ type: 'modifier', match: ['DC', 'DB&DC'] }
		]
	},
	{
		id: '11',
		label: 'Are you expecting employees to want to stay in work for longer due to lack of retirement savings?',
		options: [
			{
				label: 'Yes',
				scores: { A: 0, B: 0, C: 10, D: 10 },
				scoreConditions: {
					C: [
						{ type: 'modifier', match: ['DC', 'DB&DC'] },
					]
				},
			},
			{ label: 'No', scores: { A: 10, B: 10, C: 10, D: 0 } },
			{ label: 'Don\'t know', scores: { A: 0, B: 0, C: 0, D: 0 } },
		],
		conditions: []
	}
]
